export const getDefaultAvatarURL = (username) =>
  `https://ui-avatars.com/api/?color=ffffff&background=1687a7&uppercase=false&length=1&name=${username}`
